"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherMuscles = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const OtherMusclesItem_1 = __importDefault(require("../../atoms/OtherMusclesItem"));
const otherMuscles_1 = require("../../../mocks/otherMuscles");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
function OtherMuscles() {
    const bridge = (0, bridge_1.useBridge)();
    const [selectMuscles, setSelectMuscles] = (0, react_1.useState)(null);
    const [fadeAll, setFadeAll] = (0, react_1.useState)(false);
    const onDetailPartClick = (identifier, index) => {
        bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
            type: bridge_schema_1.InfoBoxTabType.Motion,
            identifier,
            index,
        });
        setSelectMuscles(identifier);
    };
    const onFadeAll = () => {
        setFadeAll(!fadeAll);
        bridge === null || bridge === void 0 ? void 0 : bridge.toggleFadeAllMotionActions({ type: bridge_schema_1.InfoBoxTabType.Motion });
    };
    const onHandleFade = (identifier, index) => {
        onDetailPartClick(identifier, index);
        bridge === null || bridge === void 0 ? void 0 : bridge.toggleFadeMotionAction({ type: bridge_schema_1.InfoBoxTabType.Motion, identifier });
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'OtherMuscles_Container', children: [(0, jsx_runtime_1.jsx)(FadeAllButton, { selected: fadeAll, onClick: onFadeAll, "data-e2e": 'OtherMuscles_FadeAllButton', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.motion.fadeAll) }), (0, jsx_runtime_1.jsx)(MenuItems, { "data-e2e": 'OtherMuscles_MenuItems', children: otherMuscles_1.otherMuscles.map((item, index) => ((0, jsx_runtime_1.jsx)(OtherMusclesItem_1.default, { name: item.name, isFaded: item.isFaded, isSelected: item.identifier === selectMuscles, onFade: () => {
                        onHandleFade(item.identifier, index);
                    }, onClick: () => onDetailPartClick(item.identifier, index), "data-e2e": 'OtherMuscles_OtherMusclesItem' }, item.identifier))) })] }));
}
exports.OtherMuscles = OtherMuscles;
const Container = styled_components_1.default.div `
  height: 100%;
  position: relative;
`;
const MenuItems = styled_components_1.default.div `
  height: 100%;
  background-color: inherit;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.grasshopper.background};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grasshopper.descriptionPanel.scroll.idle};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }
`;
const FadeAllButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  font-size: 14px;
  text-transform: uppercase;

  visibility: ${({ $visible = true }) => ($visible ? 'visible' : 'hidden')};
`;
